module.exports = __webpack_public_path__ + "static/media/mono_front.13664995.png";